import React from "react";
import {
  BoltIcon,
  PuzzlePieceIcon,
  GlobeAsiaAustraliaIcon,
  ChartBarIcon,
} from "@heroicons/react/24/solid";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import FeatureIcon from "./FeatureIcon";

function FeaturesSection(props) {
  const features = {
    // Left column
    left: [
      {
        title: "Tailored Solutions",
        description:
          "Every business is unique. That's why we specialize in creating custom tools to automate documentation, drawings, calculations, and more—streamlining your workflows.",
        icon: PuzzlePieceIcon,
        iconColor: "orange",
      },
      {
        title: "Global Expertise",
        description:
          "No matter where your business operates, our solutions are scalable and designed to work seamlessly across different geographies and platforms, giving you global reach.",
        icon: GlobeAsiaAustraliaIcon,
        iconColor: "teal",
      },
    ],
    // Right column
    right: [
      {
        title: "Data-Driven Decisions",
        description:
          "Leverage real-time insights with IoT and energy monitoring solutions that empower you to make informed decisions, boosting efficiency across your operations.",
        icon: ChartBarIcon,
        iconColor: "purple",
      },
      {
        title: "Blazing Fast Performance",
        description:
          "Our web apps and platforms are designed for speed and reliability, ensuring smooth performance whether you're on-site or managing your operations remotely.",
        icon: BoltIcon,
        iconColor: "yellow",
      },
    ],
  };

  return (
    <Section
      size={props.size}
      bgColor={props.bgColor}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
      textColor={props.textColor}
    >
      <div className="container">
        <div className="flex flex-col lg:flex-row lg:items-center space-y-12 lg:space-y-0 lg:space-x-20">
          <div className="lg:w-5/12 xl:w-5/12 md:py-12 space-y-10">
            <SectionHeader
              title={props.title}
              subtitle={props.subtitle}
              strapline={props.strapline}
            />
          </div>
          <div className="lg:w-7/12 xl:w-7/12 flex-none relative">
            <div className="pattern-dots opacity-10 absolute top-0 left-0 w-48 h-64 md:mt-20 transform -translate-x-10 -translate-y-10" />
            <div className="pattern-dots opacity-10 absolute bottom-0 right-0 w-48 h-64 md:mb-20 transform translate-x-10 translate-y-10" />
            <div className="relative flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
              <div className="md:w-1/2 md:mt-24 space-y-6">
                {features.left.map((feature, index) => (
                  <div
                    className="group bg-white p-5 transition ease-out duration-200 border-2 border-gray-200 rounded-2xl hover:border-gray-300"
                    key={index}
                  >
                    <FeatureIcon color={feature.iconColor} className="mb-6">
                      <feature.icon />
                    </FeatureIcon>
                    <h2 className="text-lg font-bold mb-2">{feature.title}</h2>
                    <p className="leading-relaxed text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
              <div className="md:w-1/2 space-y-6">
                {features.right.map((feature, index) => (
                  <div
                    className="group bg-white p-5 transition ease-out duration-200 border-2 border-gray-200 rounded-2xl hover:border-gray-300"
                    key={index}
                  >
                    <FeatureIcon color={feature.iconColor} className="mb-6">
                      <feature.icon />
                    </FeatureIcon>
                    <h2 className="text-lg font-bold mb-2">{feature.title}</h2>
                    <p className="leading-relaxed text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection;
